import { render } from "./GlobalNaviPreviewComponent.vue?vue&type=template&id=aa8d51d8&ts=true"
import script from "./GlobalNaviPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalNaviPreviewComponent.vue?vue&type=script&lang=ts"

import "./GlobalNaviPreviewComponent.vue?vue&type=style&index=0&id=aa8d51d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__